module.exports = __webpack_public_path__ + "static/media/surprise-meal-card.0f01ec39.wav";